import React, { useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import classes from './filters.module.css'
import classNames from 'classnames'
import { ReactComponent as Check } from '../../assets/icons/check.svg'
import { ReactComponent as Close } from '../../assets/icons/close.svg'

const Filters = ({ filters, activeFilters, redirect, onClose, open }) => {
    const [activeFilter, setActiveFilter] = useState(filters[0].id)

    const content = (
        <div
            className={classNames(
                classes.filters,
                open && classes.filtersActive
            )}
        >
            <h3 className={classes.filterHeader}>Filters</h3>
            <button className={classes.filtersClose} onClick={onClose}>
                <Close className={classes.filtersCloseIcon} />
            </button>
            <span className={classes.filterLine} />
            <div className={classes.filterBody}>
                <div className={classes.filterToggles}>
                    {filters.map(({ id, text }) => (
                        <button
                            className={classNames(
                                classes.filterToggle,
                                id === activeFilter &&
                                    classes.filterToggleActive
                            )}
                            key={id}
                            onClick={() => setActiveFilter(id)}
                        >
                            {text}
                        </button>
                    ))}
                </div>
                {filters.map(({ id: filterId, options }) => (
                    <div
                        className={classNames(
                            classes.filterOptions,
                            filterId === activeFilter &&
                                classes.filterOptionsActive
                        )}
                    >
                        {options.map(({ text, id }) => (
                            <button
                                className={classNames(
                                    classes.filterOption,
                                    String(activeFilters[filterId]) ===
                                        String(id) && classes.filterOptionActive
                                )}
                                key={id}
                                onClick={() => redirect(filterId, id)}
                            >
                                <Check
                                    className={classes.filterOptionIcon}
                                    fill={'var(--primary)'}
                                />
                                {text}
                            </button>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    )

    return createPortal(content, document.getElementById('filter-root'))
}

export default Filters
